import { schema } from 'normalizr';

export const phraseSchema = new schema.Entity('phrases', {}, { idAttribute: 'PhraseId' });

export const phraseListSchema = [phraseSchema];
